import { Box } from "@material-ui/core";
import BattleHandNotify from "./BattleHandNotify";
import ExpeditionNotify from "./ExpeditionNotify";
import TransmutationNotify from "./TransmutationNotify";
import TreasureMapNotify from "./TreasureMapNotify";
import VaultNotify from "./VaultNotify";

export default function NotifyItem({ item, isLastRecord, index }) {
  const renderNotify = () => {
    switch (item.type) {
      case "expedition":
        return <ExpeditionNotify item={item} isLastRecord={isLastRecord} />;
      case "vault":
        return <VaultNotify item={item} isLastRecord={isLastRecord} />;
      case "transmutation":
        return <TransmutationNotify item={item} isLastRecord={isLastRecord} />;
      case "battleHand":
        return <BattleHandNotify item={item} isLastRecord={isLastRecord} />;
      case "treasureMap":
        return <TreasureMapNotify item={item} isLastRecord={isLastRecord} />;
      default:
        return null;
    }
  };

  return (
    <>
      {index == 0 && <Box mt={"4px"} />}
      {renderNotify()}
    </>
  );
}
